export const StandardNames = {
  HubTransfer: 'Hub Transfer'
};
